// extracted by mini-css-extract-plugin
export default {"content":"Expertise_content__bQUSn","box":"Expertise_box__XpBOy","boxes":"Expertise_boxes__Mt0Eb"};